
<template>
  <div class="page-wrapper">
    <NavBar class="style1" />
    <div class="content-wrapper">
      <PageTitle pageTitle="EITP en mission ?" />
      <EitpMission/>
    </div>
    <FooterComp />
  </div>
</template>

<script>
import NavBar from '../Layouts/NavBar.vue'
import PageTitle from '../Common/PageTitle.vue'
import EitpMission from '../EITP/EitpMission.vue'
import FooterComp from '../Layouts/FooterComp.vue'


export default {
  name: 'EitpMissionPage',
  components: {
    NavBar,
    PageTitle,
    EitpMission,
    FooterComp,
  }
}
</script>